export default __webpack_public_path__ + "static/media/pic62.96107c54.jpg";